import {
  Box,
  CloseButton,
  Flex,
  FormControl,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Switch,
} from '@chakra-ui/react';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useEnterKey} from '../../hooks/useEnterKey';
import {folderEditFormSet, folderEditFormUpdate} from '../../reducers/pinsReducer';
import {sendDragToScroll, sendDragWithinPage} from '../../vuplex';
import PermissionBadge from './PermissionBadge';

const PinFolderCreateForm = ({}) => {
  const {_id: worldId, rules} = useSelector(s => s.inApp.world);
  const {isPrivate: isPrivateWorld, isSolo: isSoloWorld} = rules || {};
  const folderEditForm = useSelector(s => s.pins.folderEditForm);

  const {
    _id,
    isSolo,
    label,
    sharedInWorld,
  } = folderEditForm;

  const dispatch = useDispatch();

  useEffect(() => () => {
    // clear form on unmount
    dispatch(folderEditFormSet({}));
  }, []);

  useEnterKey(/*blur text field*/);

  const handleCancelClick = () => {
    dispatch(folderEditFormSet({}));
  };

  const canShareInWorld = isSolo && isPrivateWorld && !isSoloWorld;

  return (
    <Flex
      alignItems="center"
      gap={4}
      justifyContent="space-between"
      overflow="hidden"
      p={0}
      w="full"
    >
      <InputGroup
        borderColor="black24"
      >
        <InputLeftElement>
          <PermissionBadge
            isOwnedByUser
            isPrivate={isSolo}
            isShared={sharedInWorld === worldId}
            size="2em"
          />
        </InputLeftElement>

        <Input
          autoFocus={false}
          placeholder="New list"
          size="md"
          onChange={({target: {value}}) => {
            dispatch(folderEditFormUpdate({
              label: value,
            }));
          }}
          onPointerEnter={sendDragWithinPage}
          onPointerLeave={sendDragToScroll}
          value={label}
        />

        <InputRightElement w="7em">
          <FormControl
            alignItems="center"
            display="flex"
            gap={2}
            w="auto"
          >
            <Box>Public</Box>
            <Switch
              colorScheme="green"
              onChange={({target: {checked}}) => {
                dispatch(folderEditFormUpdate({
                  isSolo: !checked,
                  ...(checked ? {sharedInWorld: null} : {}),
                }));
              }}
              isChecked={!isSolo}
            />
          </FormControl>

          {/*{canShareInWorld && (*/}
          {/*  <InAppTooltip*/}
          {/*    message={'Share this list and its contents in the current world'}*/}
          {/*  >*/}
          {/*    <FormControl w="auto" display="flex">*/}
          {/*      <FormLabel>Share in world</FormLabel>*/}
          {/*      <Switch*/}
          {/*        onChange={({target: {checked}}) => {*/}
          {/*          dispatch(folderEditFormUpdate({*/}
          {/*            sharedInWorld: checked ? worldId : '',*/}
          {/*          }));*/}
          {/*        }}*/}
          {/*        isChecked={sharedInWorld === worldId}*/}
          {/*      />*/}
          {/*    </FormControl>*/}
          {/*  </InAppTooltip>*/}
          {/*)}*/}
        </InputRightElement>
      </InputGroup>

      <CloseButton
        border="1px solid"
        borderColor="black24"
        borderRadius="full"
        color="black24"
        onClick={handleCancelClick}
      />
    </Flex>
  );


};

export default PinFolderCreateForm;
